module.exports = __webpack_public_path__ + "media/images/covid/menu/sightseeing-ded56643041a7dfa0ede7e9bae4833cf.png";